import React, { useEffect, useState } from "react";
import styles from "../CommonStyles/commonstyles.module.scss";
import { useNavigate } from "react-router-dom";
import uploadedImage from "../../../../assets/images/svg/noData.png";
import noImageFound from "../../../../assets/images/svg/CertifcateCard.png";
import DeleteBox from "../../../../components/DeleteBox/DeleteBox";
import { useDispatch, useSelector } from "react-redux";
import { RiDeleteBin5Line } from "react-icons/ri";
import {
  useRemoveLicence,
  useFetchAllLicence,
} from "../../../../hooks/partnerHook/usePartnerLicence";
import { updateLicenceData } from "../../../../store/Partner/partnerDataSlice";

const Licenses = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.partner.user);
  const partnerId = userData?.partner?.id;

  const {
    data: licenseData,
    isError,
    isPending,
  } = useFetchAllLicence(partnerId);

  const {
    mutate: removeLicense,
    isError: deletionError,
    isSuccess: licenseDeleted,
  } = useRemoveLicence();

  const [licenses, setLicenses] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteName, setDeleteName] = useState("");

  useEffect(() => {
    if (licenseData) {
      console.log("Fetched License Data Before Dispatch:", licenseData);
      dispatch(updateLicenceData(licenseData));
    }
  }, [dispatch, licenseData]);

  const savedLicenses = useSelector((state) => state.partner.licence);

  console.log("Stored Licenses in Redux:", savedLicenses);

  useEffect(() => {
    if (Array.isArray(savedLicenses)) {
      setLicenses([...savedLicenses]);
    } else {
      console.error("Invalid savedLicenses data:", savedLicenses);
    }
  }, [savedLicenses]);

  const handleDelete = () => {
    if (deleteId) {
      removeLicense({ partnerId, licenceId: deleteId });
      setShowDeleteModal(false);
    }
  };

  if (isPending) {
    return <h1>Loading...</h1>;
  }

  if (isError) {
    return <h1>Error...</h1>;
  }

  return (
    <>
      <div className={styles.dashboardContainer}>
        <h2 className={styles.browseEquipmentsTitle}>Browse All Licenses</h2>
        {licenses.length > 0 ? (
          <div className={styles.dashboardGridContainer}>
            {licenses.map((license) => (
              <div
                key={license.licence_id}
                className={styles.certificateCard}
                onClick={() =>
                  navigate(`/dashboard/licenses/${license.licence_id}`)
                }
              >
                <div className={styles.imageContainer}>
                  <img
                    src={
                      license.media.length > 0
                        ? license.media[0].media_url
                        : noImageFound
                    }
                    alt={license.title}
                    className={styles.droneCardImg}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = noImageFound;
                    }}
                  />
                  <div
                    className={`${styles.verificationBadge} ${
                      license.verification_status === "success"
                        ? styles.verified
                        : styles.notVerified
                    }`}
                  >
                    {license.verification_status === "success" ? (
                      <span className={styles.verifiedIcon}>Verified</span>
                    ) : (
                      <span className={styles.notVerifiedIcon}>
                        Not Verified
                      </span>
                    )}
                  </div>
                </div>

                <div className={styles.bottomSection}>
                  <h3 className={styles.certificateTitle}>{license.title}</h3>
                  <button
                    className={styles.deleteButton}
                    onClick={(e) => {
                      e.stopPropagation();
                      setDeleteId(license.licence_id);
                      setDeleteName(license.title);
                      setShowDeleteModal(true);
                    }}
                  >
                    <RiDeleteBin5Line />
                  </button>
                </div>
              </div>
            ))}

            {showDeleteModal && (
              <DeleteBox
                deleteFunction={handleDelete}
                isSuccess={licenseDeleted}
                isError={deletionError}
                contentName={deleteName}
                setShowDeleteModal={setShowDeleteModal}
              />
            )}
          </div>
        ) : (
          <div className={styles.noDataSection}>
            <img
              src={uploadedImage}
              alt="No Data"
              className={styles.noDataImage}
            />
            <h4 className={styles.noEquipmentText}>No License Added</h4>
            <p className={styles.noEquipmentDescription}>
              Provide information about your drone pilot license, including
              license number, expiry date, and issuing authority.
            </p>
          </div>
        )}
      </div>
    </>
  );
};

export default Licenses;
